import { Card, Link, Row } from 'components/atoms';
import { IconElement } from 'types/IconElement';
import classes from 'classnames';
import React, { memo } from 'react';
import styles from './Requirements.module.scss';
import Text from 'components/atoms/Typography/Text';

export interface Requirement {
  className?: string;
  dataTest?: string;
  icon?: IconElement;
  text?: string;
  textHandler?: () => void;
  additionalTextElement?: React.ComponentType;
}

export interface RequirementsProps {
  container: Requirement[];
  cardClassName?: string;
  dataTest?: string;
}

export default memo(function Requirements({
  container,
  cardClassName,
}: RequirementsProps) {
  const renderRequirements = () =>
    container.map(
      (
        {
          text,
          additionalTextElement: AdditionalTextElement,
          icon,
          dataTest,
          textHandler,
        },
        index,
      ) => (
        <Row key={index} className={styles.row} data-test={dataTest}>
          <div className={styles.icon}>{icon}</div>
          <div>
            {text &&
              (textHandler ? (
                <Link
                  onClick={textHandler}
                  className={classes([styles.text, styles['text-style']])}
                >
                  {text}
                </Link>
              ) : (
                <Text text={text} className={styles.text} kind="p" />
              ))}
            {AdditionalTextElement && <AdditionalTextElement />}
          </div>
        </Row>
      ),
    );

  return (
    <div className={styles.container}>
      <Card className={classes(styles['requirement-card'], cardClassName)}>
        {renderRequirements()}
      </Card>
    </div>
  );
});
